import React, { Component } from 'react';
import PaygPopupInfo from "../paygPopupInfo";
import { isEmpty } from 'lodash';
import { Table, TableHead, TableRow, TableCell, TableBody, Box, CircularProgress } from '@material-ui/core';
import { TableLayout } from '../Stock/containers/Layout';
import TableFooterPagination from '../../../commonModules/interface/TableFooterPagination';
import { Skeleton } from '@material-ui/lab';

class Alerts extends Component{
    state = {
        clients:[],
        sortedClients:[],
        // confirm:'none',
        currentAlert: {},
        popUp: false,
        sortState: "sorting",
        loading: true,
        currentPage: 0,
        rowsPerPage:20,
    }
    componentDidMount = async () => {
        console.log('=================ALERTS===================');
        console.log(this.props.ALERTS);
        console.log('====================================');
        if (isEmpty(this.props.ALERTS)){
            // this.getAlerts()
            await this.props.getCustomRecoveryList("Alert")
        }
        this.setState({ loading: false})
    }
    orderByDate = () => {
        const { ALERTS, CLIENTS } = this.props;

        if( !isEmpty(ALERTS) ){
            // let client = CLIENTS[]
            let sortValue = 'sorting_desc';
            let sortedByDate = null;
            if (this.state.sortState === 'sorting_desc') {
                sortValue = 'sorting_asc';
                sortedByDate = ALERTS.sort((client1, client2) => {
                    const a = new Date(CLIENTS[client1].resume.getLastRecoveryAlert.dateNextAction);
                    const b = new Date(CLIENTS[client2].resume.getLastRecoveryAlert.dateNextAction);
                    if (a > b) {
                        return -1;
                    } else if (a < b) {
                        return 1;
                    }
                    return 0;
                });
            } else if (this.state.sortState === 'sorting' || this.state.sortState === 'sorting_asc') {
                sortedByDate = ALERTS.sort((client1, client2) => {
                    const a = new Date(CLIENTS[client1].resume.getLastRecoveryAlert.dateNextAction);
                    const b = new Date(CLIENTS[client2].resume.getLastRecoveryAlert.dateNextAction);
                    if (a < b) {
                        return -1;
                    } else if (a > b) {
                        return 1;
                    }
                    return 0;
                });
            }
            this.setState({
                sortedClients: sortedByDate,
                sortState: sortValue,
            });
        }
    }
    getAlerts = async () => { // move in Redux
        // try {
        //     const response = await fetch("/recovery/history/all", {
        //         method: 'POST',
        //         headers: {
        //             'Content-Type': 'application/json',
        //             //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
        //         },
        //         body: JSON.stringify({
        //             list:'Alert'
        //         }),
        //         credentials: 'same-origin',
        //     });
        //     const alertList = await response.json();
        //     const clients = []
        //     alertList.content.info.map((box, i) => {
        //         alertList.content.name.map((columnName, j) => {
        //             clients[i] = {...clients[i], [columnName]:box[j] }
        //         })
        //     })
        //     this.setState({ clients, sortedClients: clients });
        //     console.log('IN getAlerts ', {alertList});
        // } catch (err) {
        //     console.log(err);
        // }
        await this.props.getCustomRecoveryList("Alert")
        this.setState({ loading: false})

        // ADD PAGINATION
        
    }
    onChangePage = (pageOfItems, currentPage, rowsPerPage) => {
        // update state with new page of items
        this.setState({ pageOfItems, currentPage, rowsPerPage });
    }

    displayClientList = () => {
        const { CLIENTS, CLASSES, ALERTS, STATE } = this.props;
        const { currentPage, rowsPerPage, sortedClients } = this.state;
        if(ALERTS.length < 1) {
            return
        }
        
        let list = !isEmpty(sortedClients) ? sortedClients : ALERTS

        let fetchInfoFor = list.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage).filter(boxAssoId => !CLIENTS[boxAssoId].resume.alert_info )
        console.log('====================================');
        console.log({ fetchInfoFor});
        console.log('====================================');

        if (!isEmpty(fetchInfoFor) && !STATE.paygClients.fetching ){
            this.props.getSelectedPaygInfo("alert",fetchInfoFor, "alert_info")
        }

        return list.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage).map( ID => {
            let alert = CLIENTS[ID].resume
            // let delay = (client.paymentDelay) * -1
            // let bgm = bgColor[client.lastRecoveryActionType]
            return(
                <TableRow key={alert.id} onClick={()=>this.setState({currentAlert:alert, popUp:true})}>
                    <TableCell>{alert.getLastRecoveryAlert ? new Date(alert.getLastRecoveryAlert.dateNextAction).toLocaleDateString('fr-FR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }) : <Skeleton />}</TableCell>
                    <TableCell>{alert.idBox}</TableCell>
                    <TableCell>{alert.clientName}</TableCell>
                    <TableCell>{alert.getLastRecoveryAlert ? alert.getLastRecoveryAlert.nextActionDescription: <Skeleton /> }</TableCell>
                    <TableCell>{alert.getLastRecoveryAlert ? alert.getLastRecoveryAlert.comment: <Skeleton /> }</TableCell>
                    {/* <TableCell>{alert.done}</TableCell>
                    <TableCell>{alert.lastRecoveryAction}</TableCell> */}
                </TableRow>  
            )
        })
    }

    render(){
        console.log("ALERTS STATE", this.state);
        const { ALERTS } = this.props;
        return(
            <div>
                {this.state.popUp &&
                    <PaygPopupInfo 
                        userID={this.state.currentAlert.userID}
                        paygoID={this.state.currentAlert.idBox}
                        boxAssoId={this.state.currentAlert.boxAssoId}
                        info={this.state.currentAlert.info}
                        userInfo={this.state.currentAlert}
                        closePopup={()=>this.setState({ popUp:false })}
                        USER_INFO_LIST = {["USER", "OTHER"]}
                        BOX_INFO_LIST = {["INSTALLS", "BOX", "SYSTEM"]}
                        PAYMENTS_INFO_LIST = {["RESUME", "LIST"]} 
                        SUIVI_INFO_LIST
                        recovery 
                        default_tab = "SUIVI"
                    />
                }
                {this.state.loading ? (
                    <Box style={{textAlign: "center"}}>
                        <CircularProgress color="primary" />
                    </Box>
                ) : (
                    <TableLayout>
                        <TableHead>
                            <TableRow>
                                <TableCell className={this.state.sortState} onClick={this.orderByDate}>Date</TableCell>
                                <TableCell>Box ID</TableCell>
                                <TableCell>Nom</TableCell>
                                <TableCell>TODO</TableCell>
                                <TableCell>Info</TableCell>
                                {/* <TableCell>Action</TableCell> */}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {/* {sortedClients && 
                            sortedClients.map( alert => (
                                <TableRow key={alert.id}>
                                    <TableCell onClick={()=>this.setState({currentAlert:alert, popUp:true})}>{new Date(alert.getLastRecoveryAlert.dateNextAction).toLocaleDateString('fr-FR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</TableCell>
                                    <TableCell onClick={()=>this.setState({currentAlert:alert, popUp:true})}>{alert.idBox}</TableCell>
                                    <TableCell onClick={()=>this.setState({currentAlert:alert, popUp:true})}>{alert.clientName}</TableCell>
                                    <TableCell onClick={()=>this.setState({currentAlert:alert, popUp:true})}>{alert.getLastRecoveryAlert.nextActionDescription}</TableCell>
                                    <TableCell onClick={()=>this.setState({currentAlert:alert, popUp:true})}>{alert.getLastRecoveryAlert.comment}</TableCell>
                                    <TableCell onClick={()=>this.setState({currentAlert:alert, popUp:true})}>{alert.done}</TableCell>
                                    <TableCell onClick={()=>this.setState({currentAlert:alert, popUp:true})}>{alert.lastRecoveryAction}</TableCell>
                                </TableRow>  
                            ))
                        } */}
                        { this.displayClientList()}
                        </TableBody>
                        <TableFooterPagination
                            colSpan={6}
                            items={ALERTS} 
                            onChangePage={this.onChangePage} 
                            initialPage={this.state.currentPage} 
                        />
                    </TableLayout>
                )}
            </div>
        )
    }
}

export default Alerts;